/**
 * Created by why on 2019/10/21.
 */
/**
 * Created by why on 2019/10/21.
 */
import axios from '@/libs/api.request'
export const getByCondition = (data) => {
  return axios.request({
    url: '/log/getAllByPage',
    params: data,
    method: 'get'
  })
}

export const delByIds = (ids) => {
  return axios.request({
    url: `/log/delByIds/${ids}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/log-manage.js